// extracted by mini-css-extract-plugin
module.exports = {"text_line_height":"StartSignUpStyle_text_line_height__1QlEh","text_spacing":"StartSignUpStyle_text_spacing__25E2k"};